module.exports = {"211005001":"苏家街道","211005003":"安平街道","211005101":"汤河镇","211005201":"安平乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211005.json
// module id = 662
// module chunks = 0